export default {
  // Agent API keys (broker-scoped: org_code = broker code)
  getApiKeys: {
    method: "get",
    url: "/agent/v1/api-keys",
  },
  generateApiKey: {
    method: "post",
    url: "/agent/v1/api-keys/generate",
  },
  detail: {
    method: "get",
    url: "/user/v1/v2/organizations/:code/broker-config",
  },
  create: {
    method: "post",
    url: "/user/v1/v2/organizations/:code/broker-config",
  },
  update: {
    method: "put",
    url: "/user/v1/v2/organizations/:code/broker-config",
  },
  associatedBranches: {
    method: "get",
    url: "/user/v1/v2/brokers/:code/sections",
  },
  associateBranches: {
    method: "patch",
    url: "/user/v1/v2/brokers/:code/associate-sections",
  }
};
